import { RadioField, useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { BodyText } from '@calendly/ui/components/typography'
import { useCallback } from 'react'

import { hasLockingRule } from 'services/event_type_locking'

import { PanelContentContainer } from '../../../../styles'

const WarningBanner = () => (
  <ContextualBanner variant="warning" spacingLeft="24" spacingBottom="12">
    <BodyText size="medium">
      {I18n.t('publisher.event_type_editor.sections.scheduling_settings.managed_event_types.primary_option_locked_section_warning')}
    </BodyText>
  </ContextualBanner>
)


export const ManagedHoursOptions = () => {
  const [fieldProps] = useFormField('userRuleType')
  const [{ value: lockingRules }] = useFormField('lockingRules')
  const isLocked = hasLockingRule(lockingRules, 'v3_availability')

  const originalOnChange = fieldProps.onChange
  const onChange = useCallback(
    (_, event) => originalOnChange(event),
    [originalOnChange]
  )

  return (
    <PanelContentContainer section>
      <RadioField
        name="userRuleType"
        data-calendly-label="schedule-settings-hosts-hours"
        value="existing"
        onChange={onChange}
        label={I18n.t('publisher.event_type_editor.sections.scheduling_settings.managed_event_types.primary_option')}
      />
      {isLocked && fieldProps.value === 'existing' && <WarningBanner />}
      <RadioField
        name="userRuleType"
        data-calendly-label="schedule-settings-custom-hours"
        value="custom"
        onChange={onChange}
        label={I18n.t('publisher.event_type_editor.sections.scheduling_settings.managed_event_types.custom_option')}
      />
    </PanelContentContainer>
  )
}
